export default __webpack_public_path__ + "static/media/ready.5611d9ca.png";